import { Typography } from '@mui/material';
import { PlusCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Spacer } from 'theSource/components';
import {
  IdCardAddLinkButtonContentWrapperStyled,
  IdCardAddLinkButtonStyled,
} from './IdCardAddLinkStyled';

export const IdCardAddLink = () => {
  const { t } = useTranslation('pages.idCards');

  const navigate = useNavigate();

  const handleAddNewCard = () => navigate('new');

  return (
    <IdCardAddLinkButtonStyled
      data-testid="id-card-add-link"
      onClick={handleAddNewCard}
    >
      <IdCardAddLinkButtonContentWrapperStyled>
        <PlusCircle size={52} weight="light" />
        <Spacer height={3} />
        <Typography variant="button">{t('addIdCard')}</Typography>
      </IdCardAddLinkButtonContentWrapperStyled>
    </IdCardAddLinkButtonStyled>
  );
};
